import {graphql, useStaticQuery} from 'gatsby'
import React from 'react'

import Gallery from '@browniebroke/gatsby-image-gallery'
import {galleryWrapper} from "./photos.module.css"

const query = graphql`
  query ImagesForGallery {
    allFile(sort: {fields: name}) {
      edges {
        node {
          relativeDirectory
          childImageSharp {
            thumb: gatsbyImageData(
              width: 270
              height: 270
              placeholder: BLURRED
            )
            full: gatsbyImageData(layout: FULL_WIDTH)
          }
        }
      }
    }
  }
`

const Photos = ({name}) => {
    // todo filter by name
    const data = useStaticQuery(query)
    const images = data.allFile.edges.filter(({ node }) => node.relativeDirectory === name).map(({ node }) => node.childImageSharp)
    // `images` is an array of objects with `thumb` and `full`
    return <div className={galleryWrapper}><Gallery images={images} rowMargin={0}/></div>
}

export default Photos
